import { Table } from "antd";
import { useEffect, useState } from "react";
import { getEmployees } from "../../../../lib/getEmployees";

const PickEmployee = ({
  selectedInvoice, // Cambiamos selectedCompany por selectedInvoice
  setSelectedEmployees,
  setAdvanceFlag,
}) => {
  const columns = [
    {
      title: "Apellido y nombre",
      dataIndex: "name",
    },
    {
      title: "CUIL",
      dataIndex: "cuil",
    },
    {
      title: "Salario bruto",
      dataIndex: "salary",
      align: "right",
      render: (value) => <span>{Number(value).toLocaleString("de-DE")}</span>,
    },
  ];

  // rowSelection object indicates the need for row selection
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      if (selectedRowKeys.length > 0) {
        setAdvanceFlag(true);
      } else {
        setAdvanceFlag(false);
      }
      setSelectedEmployees(selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      name: record.name,
    }),
  };

  const [selectionType] = useState("checkbox");
  const [employeeList, setEmployeeList] = useState([]);

  useEffect(() => {
       // Si selectedInvoice tiene empleados, usamos esos empleados
       if (selectedInvoice && selectedInvoice.employees && selectedInvoice.employees.length > 0) {
        setEmployeeList(selectedInvoice.employees);
      } else {
        // Si no tiene empleados, obtenemos los empleados de la API usando selectedCompany
        getEmployees(selectedInvoice.idCompany).then((res) => {
          setEmployeeList(res.data);
        });
      }
  }, [selectedInvoice]); // Efecto se ejecuta cuando selectedInvoice cambia

  return (
    <div
      style={{
        marginTop: "10%",
      }}
    >
      <Table
        rowSelection={{
          type: selectionType,
          ...rowSelection,
        }}
        columns={columns}
        dataSource={employeeList}
        rowKey="_id"
      />
    </div>
  );
};
export default PickEmployee;
